import { makeStyles } from "@material-ui/core/styles";
import bg from "../assets/images/bg_small.jpg";
import bgDarkPurple from "../assets/images/bg_small_purple.png";

export const useStyles = makeStyles((theme) => ({
  slideClass: {
    display: "inline-block",
  },
  testSlideContents: {
    height: '800px',
    boxSizing: "border-box",
    backgroundColor: "red",
    "&.odd": {
      height: '500px',
      backgroundColor: "yellow"
    },
    "&.even": {
      height: '1000px'
    }
  },
  heroContainer: {
    position: "relative",
    backgroundImage: `url(${bgDarkPurple})`,
    backgroundBlendMode: "initial",
    display: 'flex',
    flexDirection: "column",
    boxSizing: 'border-box',
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      backgroundImage: `url(${bg}), linear-gradient(to top, ${theme.palette.darkPurple} 0%, ${theme.palette.darkPurple} 100%)`,
      backgroundBlendMode: "soft-light",
    },
    [`${theme.breakpoints.between(
      theme.breakpoints.values.md,
      theme.breakpoints.values.xl
    )} and (orientation: landscape)`]: {
      backgroundImage: `url(${bgDarkPurple})`,
      backgroundBlendMode: "initial",
    },
  },
  swiper: {
    width: "100%",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignSelf: "flex-end",
    transitionProperty: "height",
    transitionDuration: "0.2s",
    transitionTimingFunction: "ease-in-out",
  },
  hero_div: {
    height: "unset",
    width: "100%",
    margin: "0 auto",
    // backgroundImage: `url(${bgDarkPurple})`,
    // backgroundBlendMode: "initial",
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      // backgroundImage: `url(${bg}), linear-gradient(to top, ${theme.palette.darkPurple} 0%, ${theme.palette.darkPurple} 100%)`,
      // backgroundBlendMode: "soft-light",
    },
    [`${theme.breakpoints.between(
      // theme.breakpoints.values.md,
      // theme.breakpoints.values.xl
    )} and (orientation: landscape)`]: {
      // backgroundImage: `url(${bgDarkPurple})`,
      // backgroundBlendMode: "initial",
    },
  },
  slideContainer: {
    width: "100%",
    visibility: "hidden",
    transitionProperty: "visibility",
    transitionDuration: "0.0s",
    transitionDelay: "0.3s",

    "&.isActive": {
      visibility: "visible"
    },
    // "&.isNotActive": {
    //   transition: "visibility 0s ease-in 0.3s",
    //   visibility: "hidden"
    // },
    "&.userIsMoving": {
      transitionDelay: "0.0s",
      visibility: "visible !important",
    }
  },

  gridContainer: {
    maxWidth: theme.limits.lg,
    minHeight: "35.31rem",
    margin: "0 auto",
    paddingBottom: "4.5rem",
    position: "relative",
    "& p": {
      height: "auto",
    },
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      minHeight: "25rem",
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      minHeight: "31.25rem",
    }
  },
  gridContainerisFullWidth: {
    maxWidth: theme.limits.lg,
    margin: "0 auto",
    position: "absolute",
    pointerEvents: "none",
    inset: 0,
    "& p": {
      height: "auto",
    },
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
    }
  },
  gridContainerProducts: {
    maxWidth: "unset",
    margin: "0 auto",
    paddingBottom: "0",
    position: "relative",
    "& p": {
      height: "auto",
    },
  },
  navContainer: {
    display: "flex",
    width: `min(100vw, ${theme.limits.max})`,
    maxWidth: theme.limits.lg,
    minHeight: "4rem",
    margin: "0 auto",
    alignSelf: "center",
    justifySelf: "center",
    position: "absolute",
    top: "40%",
    transform: "translateY(-50%)",
    flexDirection: "row",
    alignContent: "space-between",
    padding: "0 3rem",
    zIndex: 50,
  },
  left_grid: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "auto",
    // backgroundImage: `url(${bgDarkPurple})`,
    // backgroundBlendMode: "initial",
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      // backgroundImage: `url(${bg}), linear-gradient(to top, ${theme.palette.darkPurple} 0%, ${theme.palette.darkPurple} 100%)`,
      // backgroundBlendMode: "soft-light",
    },
    [`${theme.breakpoints.between(
      // theme.breakpoints.values.md,
      // theme.breakpoints.values.xl
    )} and (orientation: landscape)`]: {
      // backgroundImage: `url(${bgDarkPurple})`,
      // backgroundBlendMode: "initial",
    },
    "& $grid1": {
      order: 1,
    },
    "& $grid2": {
      order: 2,
    },
  },
  right_grid: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "unset",
    "& $grid1": {
      [theme.breakpoints.up(theme.breakpoints.values.md)]: {
        order: 2,
      },
    },
    "& $grid2": {
      [theme.breakpoints.up(theme.breakpoints.values.md)]: {
        order: 1,
      },
    },
    "& $hero_data": {
      [theme.breakpoints.up(theme.breakpoints.values.md)]: {
        float: "right",
      },
    },
  },
  grid1: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    order: 1,
    maxHeight: "514px",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      display: "unset",
      justifyContent: "unset",
      maxHeight: "unset",
      paddingTop: "55%",
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      paddingTop: "49%",
    },
  },
  pad: {
    width: "100%",
    paddingTop: "120%",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      paddingTop: "0%",
    },
  },
  center_grid1: {
    position: "relative",
    order: 1,
  },
  grid2: {
    display: "flex",
    order: 2,
  },
  hero_bg: {
    position: "absolute",
    top: 0,
    maxWidth: "26.563rem",
    margin: "0 auto",
    width: "100%",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      maxWidth: "unset",
      width: "102%",
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      width: "94%",
      left: "calc(50% - 47%)",
    },
    [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
      width: "100%",
      left: "0",
    },
  },
  hero_image: {
    position: "absolute",
    width: "100%",
    maxWidth: "26.563rem",
    margin: "0 auto",
    top: "0",
    zIndex: 11,
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      maxWidth: "unset",
      width: "102%",
      left: "0",
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      width: "96%",
      top: "0",
      left: "calc(50% - 48%)",
    },
    [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
      width: "100%",
      top: "0",
      left: "0",
    },
  },
  hero_data: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "91.2%",
    margin: "0 auto 3.75rem auto",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      width: "87.5%",
      margin: "auto 0",
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      width: "69.48%",
    },
    [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
      width: "72%",
    },
  },
  hero_heading: {
    width: "100%",
    height: "fit-content",
    textAlign: "center",
    display: "block",
    margin: "2.188rem 0 1rem 0",
    fontSize: "3.75rem",
    color: theme.palette.yellow,
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      margin: "0 0 1rem 0",
    },
    [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
      fontSize: "5rem",
    },
  },
  hero_text: {
    display: "block",
    color: theme.palette.white,
    margin: "0 0 1rem 0",
    textAlign: "center",
    width: "100%",
    height: "fit-content",
    fontSize: "1.5rem",
    "& p": {
      fontSize: "1.5rem",
    },
    [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
      fontSize: "2rem",
      "& p": {
        fontSize: "2rem",
      },
    },
  },
  slide_footer: {
    display: "flex",
    width: "100%",
    // height: "4.5rem",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      // height: "8.125rem",
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      // height: "6.25rem",
    },
    [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
      // height: "8.125rem",
    },
  },
  hero_divider_margin: {
    height: "2rem",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      height: "4rem",
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      height: "3rem",
    },
    [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
      height: "4rem",
    },
  },
  div_mask_block: {
    backgroundColor: "transparent",
  },
  div_mask: {
    position: "absolute",
    bottom: 0,
  },
  sliderWrapperEnd: {
    position: "absolute",
    bottom: 0,
    right: 0,
    height: "50%",
    width: "100%",
    lineHeight: 0
  },
  navigation_button: {
    display: "none",
    padding: "0.375rem 0.375rem 0.188rem",
    background: "none",
    border: "none",
    transition: "all 0.1s ease-in-out",
    "&:focus": {
      backgroundColor: theme.palette.darkPurple,
      outline: "none",
      transform: "scale(1.1)"
    },

    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      display: "block",
      "&:after": {
        content: "none",
      },
      top: "41%",
      left: "2.25rem",
      width: "fit-content",
      height: "fit-content",
    },
  },
  right_btn: {
    left: "unset",
    right: "2.25rem",
  },
  navigation_svg: {
    width: "2.25rem",
    height: "2.25rem",
    color: theme.palette.white,
  },
  takis_pagination: {
    bottom: "4.5rem !important",
    left: "1.875rem",
    width: "100%",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      bottom: "2.625rem !important",
      left: "0",
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      bottom: "1.563rem !important",
    },
    [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
      bottom: "2.563rem !important",
    },
  },
  takis_pagination_btn: {
    padding: 0,
    width: "1.5rem",
    height: "1.5rem",
    margin: "0 0.5rem",
    border: "solid 0.25rem",
    borderColor: theme.palette.gridPurple,
    backgroundColor: "transparent",
    display: "inline-block",
    borderRadius: "50%",
    cursor: "pointer",

    "&:focus": {
      boxShadow: `0 0 0 0.25rem ${theme.palette.yellow}`,
      outline: "none",
    },

    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      "&:focus": {
        boxShadow: `0 0 0 0.25rem ${theme.palette.darkPurple}`,
        outline: "none",
      },
    },
  },
  takis_pagination_active: {
    backgroundColor: theme.palette.gridPurple,
  },
  center_button: {
    width: "100%",
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    bottom: "3.625rem",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      bottom: "-2.813rem",
    },
  },
  takis_image_centered: {
    position: "relative",
    display: "block",
    width: "100%",
    maxWidth: "26.563rem",
    margin: "0 auto",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      paddingBottom: "3.5rem",
      maxWidth: "unset",
    },
  },
  takis_image_no_padding: {
    position: "relative",
    display: "block",
    width: "100%",
    maxWidth: "26.563rem",
    margin: "0 auto",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      maxWidth: "unset",
    },
  },
  no_display: {
    display: "none",
  },
}));
